var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ToolbarItemContainer', {
    attrs: {
      "iconFile": _vm.imageToolbarForShow.icon,
      "title": _vm.imageToolbarForShow.title,
      "iconWidth": "20px",
      "iconHeight": "20px",
      "needDialog": false,
      "isH5ToolShow": _vm.isH5ToolShow
    },
    on: {
      "onIconClick": _vm.onIconClick
    }
  }, [_c('div', {
    class: ['image-upload', !_vm.isPC && 'image-upload-h5', 'image-video']
  }, [_c('input', {
    ref: "inputRef",
    attrs: {
      "title": _vm.props.title || _vm.TUITranslateService.t('图片'),
      "type": "file",
      "accept": "image/gif,image/jpeg,image/jpg,image/png,image/bmp,image/webp,video/mov,video/mp4"
    },
    on: {
      "change": _vm.sendImageInWeb
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }